module.exports = __webpack_public_path__ + "static/media/RS.fc6d1015.svg";